// frontend/src/hooks/useActivityVoiceFill.js
import { useState, useCallback } from 'react';
import api from '../services/api';
import useAudioRecorder from './useAudioRecorder';

// Graba audio y lo manda al backend, que devuelve los campos estructurados de una atividade.
export default function useActivityVoiceFill() {
  const recorder = useAudioRecorder();
  const [busy, setBusy] = useState(false);

  // Para la grabación y resuelve { type, subject, description, outcome, tags, priority } | null
  const stopAndFill = useCallback(async (context) => {
    const audio = await recorder.stop();
    if (!audio) return null;
    setBusy(true);
    try {
      const res = await api.post(
        '/activities/transcribe',
        { audio_base64: audio.base64, mime_type: audio.mimeType, context },
        { timeout: 180000 },
      );
      return res.data?.data?.activity || null;
    } finally {
      setBusy(false);
    }
  }, [recorder]);

  return {
    recording: recorder.recording,
    busy,
    error: recorder.error,
    start: recorder.start,
    stopAndFill,
  };
}
